import { CProducerRole } from '../mdl/c-producer-admin';
import { YId } from '../y/types';
import { the_user } from './login';

export function haveRoleInProducer(role: CProducerRole | 'any', producer_id: YId) {
    if(!the_user) return false;

    for(const r of the_user.producer_roles || []) {
        if(r.producer_id === producer_id) {
            if(role === 'any' || r.roles[role] || r.roles['admin'])
                return true;
        }
    }

    return false;
}

export function haveRoleInProducers(role: CProducerRole | 'any') {
    const producers: YId[] = [];

    if(!the_user) return producers;

    for(const r of the_user.producer_roles || []) {
        if((role === 'any' || r.roles[role] || r.roles['admin']) && r.producer_id)
            producers.push(r.producer_id);
    }

    return producers;
}

export function haveRoleInAnyProducer(role: CProducerRole) {
    if(!the_user) return false;

    for(const r of the_user.producer_roles || []) {
        if(r.roles[role] || r.roles['admin'])
            return true;
    }

    return false;
}

